var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppTabs',{attrs:{"data":_vm.tabs},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var active = ref.active;
return [(active == 0)?_c('div',[_c('Profile')],1):_vm._e(),(active == 1)?_c('div',[_c('Cards')],1):_vm._e(),(active == 2)?_c('div',[_c('Notifications')],1):_vm._e(),(active == 3)?_c('div',[_c('Discounts')],1):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }